import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { GridLine } from '../../core/components/grid/GridLine.js';
import { useCategoricalBarChartBaseConfig } from '../hooks/useCategoricalBarChartBaseConfig.js';
import { useCategoricalBarChartScales } from '../hooks/useCategoricalBarChartScales.js';
import { buildZeroLine } from '../utils/build-zero-line.js';
import { isVertical } from '../utils/layout.js';

export const CategoricalGridZeroLineLayout = () => {
  const { layout } = useCategoricalBarChartBaseConfig();
  const { valueScale: scale } = useCategoricalBarChartScales();

  const { width, height } = useGridPlotSize();
  const zeroLineValue = scale(0) ?? 0;

  const referenceSize = isVertical(layout) ? height : width;

  if (zeroLineValue === referenceSize || zeroLineValue === 0) {
    return null;
  }

  const {
    show: showLine,
    from,
    to,
  } = buildZeroLine(layout, zeroLineValue, width, height);

  return showLine ? (
    <svg className={plotLayout} data-testid="categorical-grid-zero-line-layout">
      <GridLine from={from} to={to} highlight />
    </svg>
  ) : null;
};

CategoricalGridZeroLineLayout['displayName'] = 'CategoricalGridZeroLineLayout';
